import { useSelector } from 'react-redux'
import { formatText } from '../../../../../helpers/value'
import { selectVolume } from '../store/slice'

export const Volume = () => {
  const volume = useSelector(selectVolume)

  return formatText(volume?.quantity)
}
